import React from "react";
import CartItem from "./CartItem";
import { getCurrentCart, updateCart } from "./CartData";
import { Link } from "react-router-dom";

interface Props {}

interface State {
  data: any;
  isLoading: boolean;
  noData: boolean;
}

class Cart extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      noData: false,
    };
    this.handleCheckout = this.handleCheckout.bind(this);
    this.handleQuantityPlus = this.handleQuantityPlus.bind(this);
    this.handleQuantityMinus = this.handleQuantityMinus.bind(this);
  }
  handleCheckout = () => {};
  removeCartItem = (cartItem: any, currentCart: any) => {
    //remove the item
    currentCart.pop(cartItem);
    //update the cart state and storage value
    this.setState({ data: currentCart }, () => {
      updateCart(this.state.data, "Cart");
    });
  };
  handleQuantityPlus = (e: any) => {
    if (e.target !== null && e.target !== undefined) {
      //get the item
      const cartItem = this.state.data.find(
        (item: any) => e.target.value === item.id
      );
      if (cartItem !== null || cartItem !== undefined) {
        //get the index
        let foundIndex = this.state.data.findIndex(
          (x: any) => x.id === cartItem.id
        );
        //update the quantity
        cartItem.quantity = cartItem.quantity + 1;
        //update the amount
        cartItem.totalUnitsAmount =
          cartItem.singleUnitAmount * cartItem.quantity;
        //update the array
        let currentCart = this.state.data;
        currentCart[foundIndex] = cartItem;
        //update the cart state and storage value
        this.setState({ data: currentCart }, () => {
          updateCart(this.state.data, "Cart");
        });
      }
    }
  };
  handleQuantityMinus = (e: any) => {
    if (e.target !== null && e.target !== undefined) {
      //get the item
      const cartItem = this.state.data.find(
        (item: any) => e.target.value === item.id
      );
      if (cartItem !== null || cartItem !== undefined) {
        //get the index
        let foundIndex = this.state.data.findIndex(
          (x: any) => x.id === cartItem.id
        );
        //update the quantity
        let newQauntity: number = cartItem.quantity - 1;
        let currentCart = this.state.data;

        //if the new quantity value is 0 then remove from cart
        if (newQauntity === 0) {
          this.removeCartItem(cartItem, currentCart);
        } else {
          cartItem.quantity = newQauntity;
          //update the amount
          cartItem.totalUnitsAmount =
            cartItem.singleUnitAmount * cartItem.quantity;
          //update the array
          currentCart[foundIndex] = cartItem;
          //update the cart state
          this.setState({ data: currentCart }, () => {
            //update the cart state and storage value
            updateCart(this.state.data, "Cart");
          });
        }
      }
    }
  };
  componentDidMount = () => {
    let currentCart: any = getCurrentCart("Cart");
    if (currentCart.length > 0) {
      this.setState({ data: currentCart, isLoading: false });
    } else {
      this.setState({ noData: true, isLoading: false });
    }
  };
  render() {
    if (this.state.data != null && this.state.data.length > 0) {
      const items = this.state.data.map((item: any) => (
        <CartItem
          key={"key_" + item.id + "_" + item.type + "_" + item.sizeId}
          id={item.id}
          totalUnitsAmount={item.totalUnitsAmount}
          singleUnitAmount={item.singleUnitAmount}
          item_name={item.item_name}
          quantity={item.quantity}
          thumbPath={item.thumbPath}
          discount={item.discount}
          discountAmount={item.discountAmount}
          onPlusClick={this.handleQuantityPlus}
          onMinusClick={this.handleQuantityMinus}
        />
      ));
      return (
        <div className="col-md-10 ml-auto mr-auto">
          <div className="table-responsive">
            <table className="table table-shopping">
              <thead>
                <tr>
                  <th className="text-center"></th>
                  <th></th>
                  <th className="text-right">Price</th>
                  <th className="text-right">Quantity</th>
                  <th className="text-right">Total</th>
                </tr>
              </thead>
              <tbody>{items}</tbody>
            </table>
          </div>
          <div className="col-md-4">
            <Link className="nav-link" to={`../checkout`}>
              <button className="btn btn-success btn-block btn-round">
                Checkout &nbsp;
                <i className="fa fa-chevron-right"></i>
              </button>
            </Link>
          </div>
          <div className="col-md-8"></div>
        </div>
      );
    } else {
      return (
        <div className="alert alert-info">
          <div className="container">
            <span>Your Shopping Cart Is Empty </span>
          </div>
        </div>
      );
    }
  }
}

export default Cart;
